export const formatCurrencyNegative = (amount: number): string => {
	const formatted = amount.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 2,
	});

	return amount === 0 ? formatted : `(${formatted})`;
};

export const formatCurrencyPositive = (amount: number): string => {
	const formatted = amount.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 2,
	});

	return formatted;
};

export const formatCurrency = (amount: number): string => {
	if (amount >= 0) return formatCurrencyPositive(amount);
	return formatCurrencyNegative(amount * -1);
};

export function formatEnumValueForDisplay(enumValue: string) {
	if (!enumValue) return '';

	const splitValue = enumValue.split('_');

	return splitValue
		.map((word) => {
			const lowerCaseWord = word.toLowerCase();
			return lowerCaseWord.charAt(0).toUpperCase() + lowerCaseWord.slice(1);
		})
		.join(' ');
}

export function formatEnumValueToCamelcase(enumValue: string) {
	if (!enumValue) {
		return '';
	}

	const splitValue = enumValue.split('_');

	return splitValue
		.map((word, index) => {
			const lowerCaseWord = word.toLowerCase();
			if (index === 0) {
				return lowerCaseWord;
			}
			return lowerCaseWord.charAt(0).toUpperCase() + lowerCaseWord.slice(1);
		})
		.join('');
}

export function formatCamelcaseToEnumValue(camelCaseValue: string) {
	if (!camelCaseValue) {
		return '';
	}

	const splitValue = camelCaseValue.split(/(?=[A-Z])/);

	return splitValue.map((word) => word.toUpperCase()).join('_');
}
